module.exports = __webpack_public_path__ + "static/dmon-009-6a865d18cfb9962a26842c8d39eb2f95.jpg";